if (!customElements.get("lsg-ingridients")) customElements.define("lsg-ingridients", class LSGIngridients extends HTMLElement {
    constructor() {
        super();
        this.selectors = {
            toggle: ".js-lsg-ingridients-toggle",
            content: ".js-lsg-ingridients-content"
        };
        this.toggle = this.querySelectorAll(this.selectors.toggle);
        this.content = this.querySelectorAll(this.selectors.content);
        this.init();
    }

    init() {
        this.toggle.forEach(el => {
            el.addEventListener('click', () => {
                const isExpanded = el.getAttribute('aria-expanded') == 'true' ? true : false;
                this.content.forEach(item => {
                    item.classList.remove('is-open');
                });
                this.toggle.forEach(item => {
                    el.setAttribute('aria-expanded', false);
                });
                el.setAttribute('aria-expanded', !isExpanded);
                if (isExpanded == false) {
                    document.querySelector('#' + el.getAttribute('aria-controls')).classList.add('is-open');
                }
            })
        });
    }
});
